import { URL, handleErrors } from "./depannageActions"
import { showToast, toastApiError } from "./toastActions"
import { catchApiError } from "./apiHelpers"

export const FETCH_FOURNISSEURS_BEGIN = "FETCH_FOURNISSEURS_BEGIN"
export const FETCH_FOURNISSEURS_ERROR = "FETCH_FOURNISSEURS_ERROR"
export const FETCH_FOURNISSEURS_SUCCESS = "FETCH_FOURNISSEURS_SUCCESS"

export const fetchFournisseursBegin = () => ({
	type: FETCH_FOURNISSEURS_BEGIN,
})

export const fetchFournisseursError = (payload) => ({
	type: FETCH_FOURNISSEURS_ERROR,
	payload,
})

export const fetchFournisseursSuccess = (payload) => ({
	type: FETCH_FOURNISSEURS_SUCCESS,
	payload,
})

export function fetchFournisseurs() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchFournisseursBegin())
		let url = `${URL}api/fournisseurs`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchFournisseursSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchFournisseursError))
	}
}

export const FETCH_FOURNITURES_BEGIN = "FETCH_FOURNITURES_BEGIN"
export const FETCH_FOURNITURES_ERROR = "FETCH_FOURNITURES_ERROR"
export const FETCH_FOURNITURES_SUCCESS = "FETCH_FOURNITURES_SUCCESS"

export const fetchFournituresBegin = () => ({
	type: FETCH_FOURNITURES_BEGIN,
})

export const fetchFournituresError = (payload) => ({
	type: FETCH_FOURNITURES_ERROR,
	payload,
})

export const fetchFournituresSuccess = (payload) => ({
	type: FETCH_FOURNITURES_SUCCESS,
	payload,
})

export function fetchFournitures(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchFournituresBegin())
		let url = `${URL}api/fournitures?id=${id}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchFournituresSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchFournituresError))
	}
}

export const FETCH_AUTRE_ENTITES_BEGIN = "FETCH_AUTRE_ENTITES_BEGIN"
export const FETCH_AUTRE_ENTITES_ERROR = "FETCH_AUTRE_ENTITES_ERROR"
export const FETCH_AUTRE_ENTITES_SUCCESS = "FETCH_AUTRE_ENTITES_SUCCESS"

export const fetchAutreEntitesBegin = () => ({
	type: FETCH_AUTRE_ENTITES_BEGIN,
})

export const fetchAutreEntitesError = (payload) => ({
	type: FETCH_AUTRE_ENTITES_ERROR,
	payload,
})

export const fetchAutreEntitesSuccess = (payload) => ({
	type: FETCH_AUTRE_ENTITES_SUCCESS,
	payload,
})

export function fetchAutreEntites() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchAutreEntitesBegin())
		let url = `${URL}api/autre_entites`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchAutreEntitesSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchAutreEntitesError))
	}
}

//////////////////////////////////////////////////////////////
//                          Paye Par                        //
//////////////////////////////////////////////////////////////

export const FETCH_PAYEPAR_BEGIN = "FETCH_PAYEPAR_BEGIN"
export const FETCH_PAYEPAR_ERROR = "FETCH_PAYEPAR_ERROR"
export const FETCH_PAYEPAR_SUCCESS = "FETCH_PAYEPAR_SUCCESS"

export const fetchPayeParBegin = () => ({
	type: FETCH_PAYEPAR_BEGIN,
})

export const fetchPayeParError = (payload) => ({
	type: FETCH_PAYEPAR_ERROR,
	payload,
})

export const fetchPayeParSuccess = (payload) => ({
	type: FETCH_PAYEPAR_SUCCESS,
	payload,
})

export function fetchPayePar() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchPayeParBegin())
		let url = `${URL}api/payepar`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchPayeParSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchPayeParError))
	}
}

export const POST_PAYEPAR_BEGIN = "POST_PAYEPAR_BEGIN"
export const POST_PAYEPAR_ERROR = "POST_PAYEPAR_ERROR"
export const POST_PAYEPAR_SUCCESS = "POST_PAYEPAR_SUCCESS"
export const POST_PAYEPAR_RESET = "POST_PAYEPAR_RESET"

export const postPayeParBegin = () => ({
	type: POST_PAYEPAR_BEGIN,
})

export const postPayeParReset = () => ({
	type: POST_PAYEPAR_RESET,
})

export const postPayeParError = (payload) => ({
	type: POST_PAYEPAR_ERROR,
	payload,
})

export const postPayeParSuccess = (payload) => ({
	type: POST_PAYEPAR_SUCCESS,
	payload,
})

export function postPayePar(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postPayeParBegin())
		return fetch(`${URL}api/payepar`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: data,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postPayeParSuccess(json))
			})
			.catch(catchApiError(dispatch, postPayeParError))
	}
}

export const DELETE_PAYEPAR_BEGIN = "DELETE_PAYEPAR_BEGIN"
export const DELETE_PAYEPAR_SUCCESS = "DELETE_PAYEPAR_SUCCESS"
export const DELETE_PAYEPAR_ERROR = "DELETE_PAYEPAR_ERROR"
export const DELETE_PAYEPAR_RESET = "DELETE_PAYEPAR_RESET"

export const deletePayeParBegin = () => ({
	type: DELETE_PAYEPAR_BEGIN,
})

export const deletePayeParSuccess = (payload) => ({
	type: DELETE_PAYEPAR_SUCCESS,
	payload,
})

export const deletePayeParError = (payload) => ({
	type: DELETE_PAYEPAR_ERROR,
	payload,
})

export const deletePayeParReset = () => ({
	type: DELETE_PAYEPAR_RESET,
})

export function deletePayePar(kwargs) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deletePayeParBegin())
		return fetch(`${URL}api/payepar`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: kwargs,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(deletePayeParSuccess(json)))
			.catch(catchApiError(dispatch, deletePayeParError))
	}
}

//////////////////////////////////////////////////////////////
//                    Moyen Paiement                        //
//////////////////////////////////////////////////////////////

export const FETCH_MOYENPAIEMENTS_BEGIN = "FETCH_MOYENPAIEMENTS_BEGIN"
export const FETCH_MOYENPAIEMENTS_ERROR = "FETCH_MOYENPAIEMENTS_ERROR"
export const FETCH_MOYENPAIEMENTS_SUCCESS = "FETCH_MOYENPAIEMENTS_SUCCESS"

export const fetchMoyenPaiementsBegin = () => ({
	type: FETCH_MOYENPAIEMENTS_BEGIN,
})

export const fetchMoyenPaiementsError = (error) => ({
	type: FETCH_MOYENPAIEMENTS_ERROR,
	payload: { error },
})

export const fetchMoyenPaiementsSuccess = (moyenPaiements) => ({
	type: FETCH_MOYENPAIEMENTS_SUCCESS,
	payload: { moyenPaiements },
})

export function fetchMoyenPaiements() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchMoyenPaiementsBegin())
		let url = `${URL}api/moyenpaiements`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchMoyenPaiementsSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchMoyenPaiementsError))
	}
}

export const POST_MOYENPAIEMENTS_BEGIN = "POST_MOYENPAIEMENTS_BEGIN"
export const POST_MOYENPAIEMENTS_ERROR = "POST_MOYENPAIEMENTS_ERROR"
export const POST_MOYENPAIEMENTS_SUCCESS = "POST_MOYENPAIEMENTS_SUCCESS"
export const POST_MOYENPAIEMENTS_RESET = "POST_MOYENPAIEMENTS_RESET"

export const postMoyenPaiementsBegin = () => ({
	type: POST_MOYENPAIEMENTS_BEGIN,
})

export const postMoyenPaiementsReset = () => ({
	type: POST_MOYENPAIEMENTS_RESET,
})

export const postMoyenPaiementsError = (error) => ({
	type: POST_MOYENPAIEMENTS_ERROR,
	payload: { error },
})

export const postMoyenPaiementsSuccess = (moyenPaiements) => ({
	type: POST_MOYENPAIEMENTS_SUCCESS,
	payload: { moyenPaiements },
})

export function postMoyenPaiements(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postMoyenPaiementsBegin())
		return fetch(`${URL}api/moyenpaiements`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: data,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postMoyenPaiementsSuccess(json))
				dispatch(showToast("success", "Moyen de paiement enregistré"))
			})
			.catch(catchApiError(dispatch, postMoyenPaiementsError))
	}
}

export const DELETE_MOYENPAIEMENT_BEGIN = "DELETE_MOYENPAIEMENT_BEGIN"
export const DELETE_MOYENPAIEMENT_SUCCESS = "DELETE_MOYENPAIEMENT_SUCCESS"
export const DELETE_MOYENPAIEMENT_ERROR = "DELETE_MOYENPAIEMENT_ERROR"
export const DELETE_MOYENPAIEMENT_RESET = "DELETE_MOYENPAIEMENT_RESET"

export const deleteMoyenPaiementBegin = () => ({
	type: DELETE_MOYENPAIEMENT_BEGIN,
})

export const deleteMoyenPaiementSuccess = (moyenPaiements) => ({
	type: DELETE_MOYENPAIEMENT_SUCCESS,
	payload: { moyenPaiements },
})

export const deleteMoyenPaiementError = (error) => ({
	type: DELETE_MOYENPAIEMENT_ERROR,
	payload: { error },
})

export const deleteMoyenPaiementReset = () => ({
	type: DELETE_MOYENPAIEMENT_RESET,
})

export function deleteMoyenPaiement(kwargs) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteMoyenPaiementBegin())
		return fetch(`${URL}api/moyenpaiements`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: kwargs,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(deleteMoyenPaiementSuccess(json))
				dispatch(showToast("success", "Moyen de paiement supprimé"))
			})
			.catch(catchApiError(dispatch, deleteMoyenPaiementError))
	}
}

//////////////////////////////////////////////////////////////
//                          Options                         //
//////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////
//                          Marques                         //
//////////////////////////////////////////////////////////////

export const FETCH_MARQUES_BEGIN = "FETCH_MARQUES_BEGIN"
export const FETCH_MARQUES_ERROR = "FETCH_MARQUES_ERROR"
export const FETCH_MARQUES_SUCCESS = "FETCH_MARQUES_SUCCESS"

export const fetchMarquesBegin = () => ({
	type: FETCH_MARQUES_BEGIN,
})

export const fetchMarquesError = (error) => ({
	type: FETCH_MARQUES_ERROR,
	payload: { error },
})

export const fetchMarquesSuccess = (marques) => ({
	type: FETCH_MARQUES_SUCCESS,
	payload: { marques },
})

export function fetchMarques() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchMarquesBegin())
		let url = `${URL}api/marques`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchMarquesSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchMarquesError))
	}
}

export const POST_MARQUE_BEGIN = "POST_MARQUE_BEGIN"
export const POST_MARQUE_ERROR = "POST_MARQUE_ERROR"
export const POST_MARQUE_SUCCESS = "POST_MARQUE_SUCCESS"
export const POST_MARQUE_RESET = "POST_MARQUE_RESET"

export const postMarqueBegin = () => ({
	type: POST_MARQUE_BEGIN,
})

export const postMarqueReset = () => ({
	type: POST_MARQUE_RESET,
})

export const postMarqueError = (error) => ({
	type: POST_MARQUE_ERROR,
	payload: { error },
})

export const postMarqueSuccess = (marques) => ({
	type: POST_MARQUE_SUCCESS,
	payload: { marques },
})

export function postMarque(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postMarqueBegin())
		return fetch(`${URL}api/modeles`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: data,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postMarqueSuccess(json))
				dispatch(showToast("success", "Marque enregistrée"))
			})
			.catch(catchApiError(dispatch, postMarqueError))
	}
}

export const DELETE_MARQUE_BEGIN = "DELETE_MARQUE_BEGIN"
export const DELETE_MARQUE_SUCCESS = "DELETE_MARQUE_SUCCESS"
export const DELETE_MARQUE_ERROR = "DELETE_MARQUE_ERROR"
export const DELETE_MARQUE_RESET = "DELETE_MARQUE_RESET"

export const deleteMarqueBegin = () => ({
	type: DELETE_MARQUE_BEGIN,
})

export const deleteMarqueSuccess = (marques) => ({
	type: DELETE_MARQUE_SUCCESS,
	payload: { marques },
})

export const deleteMarqueError = (error) => ({
	type: DELETE_MARQUE_ERROR,
	payload: { error },
})

export const deleteMarqueReset = () => ({
	type: DELETE_MARQUE_RESET,
})

export function deleteMarque(kwargs) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteMarqueBegin())
		return fetch(`${URL}api/marques`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: kwargs,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(deleteMarqueSuccess(json))
				dispatch(showToast("success", "Marque supprimée"))
			})
			.catch(catchApiError(dispatch, deleteMarqueError))
	}
}

//////////////////////////////////////////////////////////////
//                          Modèles                         //
//////////////////////////////////////////////////////////////

export const FETCH_MODELES_BEGIN = "FETCH_MODELES_BEGIN"
export const FETCH_MODELES_ERROR = "FETCH_MODELES_ERROR"
export const FETCH_MODELES_SUCCESS = "FETCH_MODELES_SUCCESS"

export const fetchVehModelesBegin = () => ({
	type: FETCH_MODELES_BEGIN,
})

export const fetchVehModelesError = (error) => ({
	type: FETCH_MODELES_ERROR,
	payload: { error },
})

export const fetchVehModelesSuccess = (modeles) => ({
	type: FETCH_MODELES_SUCCESS,
	payload: { modeles },
})

export function fetchVehModeles(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		if (id === 0) {
			dispatch(fetchVehModelesSuccess([]))
			return Promise.resolve()
		}
		dispatch(fetchVehModelesBegin())
		let url = `${URL}api/modeles?id=${id}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchVehModelesSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchVehModelesError))
	}
}

export const DELETE_MODELE_BEGIN = "DELETE_MODELE_BEGIN"
export const DELETE_MODELE_SUCCESS = "DELETE_MODELE_SUCCESS"
export const DELETE_MODELE_ERROR = "DELETE_MODELE_ERROR"
export const DELETE_MODELE_RESET = "DELETE_MODELE_RESET"

export const deleteModeleBegin = () => ({
	type: DELETE_MODELE_BEGIN,
})

export const deleteModeleSuccess = (modeles) => ({
	type: DELETE_MODELE_SUCCESS,
	payload: { modeles },
})

export const deleteModeleError = (error) => ({
	type: DELETE_MODELE_ERROR,
	payload: { error },
})

export const deleteModeleReset = () => ({
	type: DELETE_MODELE_RESET,
})

export function deleteModele(kwargs) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteModeleBegin())
		return fetch(`${URL}api/modeles`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: kwargs,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(deleteModeleSuccess(json))
				dispatch(showToast("success", "Modèle supprimé"))
			})
			.catch(catchApiError(dispatch, deleteModeleError))
	}
}

//////////////////////////////////////////////////////////////
//                          Secteurs                        //
//////////////////////////////////////////////////////////////

export const FETCH_SECTEURS_BEGIN = "FETCH_SECTEURS_BEGIN"
export const FETCH_SECTEURS_ERROR = "FETCH_SECTEURS_ERROR"
export const FETCH_SECTEURS_SUCCESS = "FETCH_SECTEURS_SUCCESS"

export const fetchSecteursBegin = () => ({
	type: FETCH_SECTEURS_BEGIN,
})

export const fetchSecteursError = (error) => ({
	type: FETCH_SECTEURS_ERROR,
	payload: { error },
})

export const fetchSecteursSuccess = (secteurs) => ({
	type: FETCH_SECTEURS_SUCCESS,
	payload: { secteurs },
})

export function fetchSecteurs() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchSecteursBegin())
		let url = `${URL}api/secteurs`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchSecteursSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchSecteursError))
	}
}

export const POST_SECTEURS_BEGIN = "POST_SECTEURS_BEGIN"
export const POST_SECTEURS_ERROR = "POST_SECTEURS_ERROR"
export const POST_SECTEURS_SUCCESS = "POST_SECTEURS_SUCCESS"
export const POST_SECTEURS_RESET = "POST_SECTEURS_RESET"

export const postSecteursBegin = () => ({
	type: POST_SECTEURS_BEGIN,
})

export const postSecteursReset = () => ({
	type: POST_SECTEURS_RESET,
})

export const postSecteursError = (error) => ({
	type: POST_SECTEURS_ERROR,
	payload: { error },
})

export const postSecteursSuccess = (secteurs) => ({
	type: POST_SECTEURS_SUCCESS,
	payload: { secteurs },
})

export function postSecteurs(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postSecteursBegin())
		return fetch(`${URL}api/secteurs`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: data,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postSecteursSuccess(json))
				dispatch(showToast("success", "Secteur enregistré"))
			})
			.catch(catchApiError(dispatch, postSecteursError))
	}
}

export const DELETE_SECTEUR_BEGIN = "DELETE_SECTEUR_BEGIN"
export const DELETE_SECTEUR_SUCCESS = "DELETE_SECTEUR_SUCCESS"
export const DELETE_SECTEUR_ERROR = "DELETE_SECTEUR_ERROR"
export const DELETE_SECTEUR_RESET = "DELETE_SECTEUR_RESET"

export const deleteSecteurBegin = () => ({
	type: DELETE_SECTEUR_BEGIN,
})

export const deleteSecteurSuccess = (secteurs) => ({
	type: DELETE_SECTEUR_SUCCESS,
	payload: { secteurs },
})

export const deleteSecteurError = (error) => ({
	type: DELETE_SECTEUR_ERROR,
	payload: { error },
})

export const deleteSecteurReset = () => ({
	type: DELETE_SECTEUR_RESET,
})

export function deleteSecteur(kwargs) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteSecteurBegin())
		return fetch(`${URL}api/secteurs`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: kwargs,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(deleteSecteurSuccess(json))
				dispatch(showToast("success", "Secteur supprimé"))
			})
			.catch(catchApiError(dispatch, deleteSecteurError))
	}
}

//////////////////////////////////////////////////////////////
//                      Taches autre                        //
//////////////////////////////////////////////////////////////

export const FETCH_TACHES_AUTRE_BEGIN = "FETCH_TACHES_AUTRE_BEGIN"
export const FETCH_TACHES_AUTRE_ERROR = "FETCH_TACHES_AUTRE_ERROR"
export const FETCH_TACHES_AUTRE_SUCCESS = "FETCH_TACHES_AUTRE_SUCCESS"

export const fetchTachesAutreBegin = () => ({
	type: FETCH_TACHES_AUTRE_BEGIN,
})

export const fetchTachesAutreError = (error) => ({
	type: FETCH_TACHES_AUTRE_ERROR,
	payload: { error },
})

export const fetchTachesAutreSuccess = (taches) => ({
	type: FETCH_TACHES_AUTRE_SUCCESS,
	payload: { ...taches },
})

export function fetchTachesAutre() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchTachesAutreBegin())
		let url = `${URL}api/tacheautre`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchTachesAutreSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchTachesAutreError))
	}
}

export const POST_TACHES_AUTRE_BEGIN = "POST_TACHES_AUTRE_BEGIN"
export const POST_TACHES_AUTRE_ERROR = "POST_TACHES_AUTRE_ERROR"
export const POST_TACHES_AUTRE_SUCCESS = "POST_TACHES_AUTRE_SUCCESS"
export const POST_TACHES_AUTRE_RESET = "POST_TACHES_AUTRE_RESET"

export const postTachesAutreBegin = () => ({
	type: POST_TACHES_AUTRE_BEGIN,
})

export const postTachesAutreReset = () => ({
	type: POST_TACHES_AUTRE_RESET,
})

export const postTachesAutreError = (error) => ({
	type: POST_TACHES_AUTRE_ERROR,
	payload: { error },
})

export const postTachesAutreSuccess = (taches) => ({
	type: POST_TACHES_AUTRE_SUCCESS,
	payload: { ...taches },
})

export function postTachesAutre(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postTachesAutreBegin())
		return fetch(`${URL}api/tacheautre`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: data,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postTachesAutreSuccess(json))
				dispatch(showToast("success", "Tâche enregistrée"))
			})
			.catch(catchApiError(dispatch, postTachesAutreError))
	}
}

export const DELETE_TACHE_AUTRE_BEGIN = "DELETE_TACHE_AUTRE_BEGIN"
export const DELETE_TACHE_AUTRE_SUCCESS = "DELETE_TACHE_AUTRE_SUCCESS"
export const DELETE_TACHE_AUTRE_ERROR = "DELETE_TACHE_AUTRE_ERROR"
export const DELETE_TACHE_AUTRE_RESET = "DELETE_TACHE_AUTRE_RESET"

export const deleteTacheAutreBegin = () => ({
	type: DELETE_TACHE_AUTRE_BEGIN,
})

export const deleteTacheAutreSuccess = (taches) => ({
	type: DELETE_TACHE_AUTRE_SUCCESS,
	payload: { ...taches },
})

export const deleteTacheAutreError = (error) => ({
	type: DELETE_TACHE_AUTRE_ERROR,
	payload: { error },
})

export const deleteTacheAutreReset = () => ({
	type: DELETE_TACHE_AUTRE_RESET,
})

export function deleteTacheAutre(kwargs) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteTacheAutreBegin())
		return fetch(`${URL}api/tacheautre`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: kwargs,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(deleteTacheAutreSuccess(json))
				dispatch(showToast("success", "Tâche supprimée"))
			})
			.catch(catchApiError(dispatch, deleteTacheAutreError))
	}
}

// ===== Catalogue des tâches véhicule (TypeTacheVehicule) =====
// api/types-taches-vehicule renvoie la LISTE des types actifs (avec portee +
// portee_types / portee_vehicules). POST = create/update, DELETE = soft-delete.

export const FETCH_TYPES_TV_BEGIN = "FETCH_TYPES_TV_BEGIN"
export const FETCH_TYPES_TV_SUCCESS = "FETCH_TYPES_TV_SUCCESS"
export const FETCH_TYPES_TV_ERROR = "FETCH_TYPES_TV_ERROR"
export const POST_TYPE_TV_BEGIN = "POST_TYPE_TV_BEGIN"
export const POST_TYPE_TV_SUCCESS = "POST_TYPE_TV_SUCCESS"
export const POST_TYPE_TV_ERROR = "POST_TYPE_TV_ERROR"
export const POST_TYPE_TV_RESET = "POST_TYPE_TV_RESET"
export const DELETE_TYPE_TV_BEGIN = "DELETE_TYPE_TV_BEGIN"
export const DELETE_TYPE_TV_SUCCESS = "DELETE_TYPE_TV_SUCCESS"
export const DELETE_TYPE_TV_ERROR = "DELETE_TYPE_TV_ERROR"
export const DELETE_TYPE_TV_RESET = "DELETE_TYPE_TV_RESET"

const TYPES_TV_URL = `${URL}api/types-taches-vehicule`

export function fetchTypesTacheVehicule() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: FETCH_TYPES_TV_BEGIN })
		return fetch(TYPES_TV_URL, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) =>
				dispatch({ type: FETCH_TYPES_TV_SUCCESS, payload: json }),
			)
			.catch(() => dispatch({ type: FETCH_TYPES_TV_ERROR }))
	}
}

export const postTypeTacheVehiculeReset = () => ({ type: POST_TYPE_TV_RESET })

export function postTypeTacheVehicule(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: POST_TYPE_TV_BEGIN })
		return fetch(TYPES_TV_URL, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: data,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch({ type: POST_TYPE_TV_SUCCESS, payload: json })
				dispatch(showToast("success", "Tâche enregistrée"))
			})
			.catch(
				catchApiError(dispatch, (payload) => ({
					type: POST_TYPE_TV_ERROR,
					payload,
				})),
			)
	}
}

export const deleteTypeTacheVehiculeReset = () => ({
	type: DELETE_TYPE_TV_RESET,
})

export function deleteTypeTacheVehicule(kwargs) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: DELETE_TYPE_TV_BEGIN })
		return fetch(TYPES_TV_URL, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: kwargs,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch({ type: DELETE_TYPE_TV_SUCCESS, payload: json })
				dispatch(showToast("success", "Tâche supprimée"))
			})
			.catch(
				catchApiError(dispatch, (payload) => ({
					type: DELETE_TYPE_TV_ERROR,
					payload,
				})),
			)
	}
}

// ===== Flotte master (config) : save/delete par véhicule, façon RH =====
// L'endpoint api/configuration/vehicule (boss-only) renvoie la flotte complète,
// stockée dans masterReducer.masterVehicules. Dates en ISO (YYYY-MM-DD).

export const POST_VEHICULE_CONFIG_BEGIN = "POST_VEHICULE_CONFIG_BEGIN"
export const POST_VEHICULE_CONFIG_SUCCESS = "POST_VEHICULE_CONFIG_SUCCESS"
export const POST_VEHICULE_CONFIG_ERROR = "POST_VEHICULE_CONFIG_ERROR"
export const POST_VEHICULE_CONFIG_RESET = "POST_VEHICULE_CONFIG_RESET"
export const DELETE_VEHICULE_CONFIG_BEGIN = "DELETE_VEHICULE_CONFIG_BEGIN"
export const DELETE_VEHICULE_CONFIG_SUCCESS = "DELETE_VEHICULE_CONFIG_SUCCESS"
export const DELETE_VEHICULE_CONFIG_ERROR = "DELETE_VEHICULE_CONFIG_ERROR"
export const DELETE_VEHICULE_CONFIG_RESET = "DELETE_VEHICULE_CONFIG_RESET"

// Merge des documents (files + carte_grise) d'un véhicule du parc master, après
// upload/suppression — évite des fichiers périmés à la réouverture du modal.
export const UPDATE_MASTER_VEHICULE_DOCS = "UPDATE_MASTER_VEHICULE_DOCS"
export const updateMasterVehiculeDocs = (id, docs) => ({
	type: UPDATE_MASTER_VEHICULE_DOCS,
	payload: { id, docs },
})

export const postVehiculeConfigBegin = () => ({
	type: POST_VEHICULE_CONFIG_BEGIN,
})
export const postVehiculeConfigSuccess = (vehicules) => ({
	type: POST_VEHICULE_CONFIG_SUCCESS,
	payload: { vehicules },
})
export const postVehiculeConfigError = (error) => ({
	type: POST_VEHICULE_CONFIG_ERROR,
	payload: { error },
})
export const postVehiculeConfigReset = () => ({
	type: POST_VEHICULE_CONFIG_RESET,
})

export const deleteVehiculeConfigBegin = () => ({
	type: DELETE_VEHICULE_CONFIG_BEGIN,
})
export const deleteVehiculeConfigSuccess = (vehicules) => ({
	type: DELETE_VEHICULE_CONFIG_SUCCESS,
	payload: { vehicules },
})
export const deleteVehiculeConfigError = (error) => ({
	type: DELETE_VEHICULE_CONFIG_ERROR,
	payload: { error },
})
export const deleteVehiculeConfigReset = () => ({
	type: DELETE_VEHICULE_CONFIG_RESET,
})

export function postVehiculeConfig(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postVehiculeConfigBegin())
		return (
			fetch(`${URL}api/configuration/vehicule`, {
				method: "post",
				headers: {
					Accept: "application/json, text/plain",
					"Content-type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				body: JSON.stringify(data),
			})
				.then(handleErrors)
				.then((res) => res.json())
				.then((json) => {
					dispatch(postVehiculeConfigSuccess(json))
					dispatch(
						showToast(
							"success",
							data.id ? "Véhicule modifié" : "Véhicule créé",
						),
					)
				})
				// silent : l'erreur s'affiche dans VehiculeV2 (règle hybride).
				.catch(
					catchApiError(dispatch, postVehiculeConfigError, {
						silent: true,
					}),
				)
		)
	}
}

// ===== Œil véhicule d'une fiche d'entretien : accès dédié =====
// api/vehicule/fiche-entretien (droit `vehicule_fiche_entretien`) : lecture et
// modification d'UN véhicule existant de la flotte, sans création, suppression
// ni sortie du parc. Même machine d'état que la flotte (`postVehicule`) pour
// que VehiculeV2 n'ait qu'un seul cycle d'enregistrement.
export const PUT_VEHICULE_FICHE_SUCCESS = "PUT_VEHICULE_FICHE_SUCCESS"

export function fetchVehiculeFicheEntretien(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/vehicule/fiche-entretien?id=${id}`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.catch(catchApiError(dispatch, null))
	}
}

export function putVehiculeFicheEntretien(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postVehiculeConfigBegin())
		return (
			fetch(`${URL}api/vehicule/fiche-entretien`, {
				method: "put",
				headers: {
					Accept: "application/json, text/plain",
					"Content-type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				body: JSON.stringify(data),
			})
				.then(handleErrors)
				.then((res) => res.json())
				.then((json) => {
					dispatch({
						type: PUT_VEHICULE_FICHE_SUCCESS,
						payload: { vehicule: json },
					})
					dispatch(showToast("success", "Véhicule modifié"))
				})
				// silent : l'erreur s'affiche dans VehiculeV2 (règle hybride).
				.catch(
					catchApiError(dispatch, postVehiculeConfigError, {
						silent: true,
					}),
				)
		)
	}
}

export const FETCH_FLOTTE_SUCCESS = "FETCH_FLOTTE_SUCCESS"

export function fetchFlotte(inclureSortis = false) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(
			`${URL}api/configuration/vehicule?inclure_sortis=${inclureSortis ? "1" : "0"}`,
			{
				headers: { Authorization: `Bearer ${token}` },
			},
		)
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) =>
				dispatch({
					type: FETCH_FLOTTE_SUCCESS,
					payload: { vehicules: json },
				}),
			)
			.catch(catchApiError(dispatch, postVehiculeConfigError))
	}
}

export const SORTIE_VEHICULE_BEGIN = "SORTIE_VEHICULE_BEGIN"
export const SORTIE_VEHICULE_SUCCESS = "SORTIE_VEHICULE_SUCCESS"
export const SORTIE_VEHICULE_ERROR = "SORTIE_VEHICULE_ERROR"
export const SORTIE_VEHICULE_RESET = "SORTIE_VEHICULE_RESET"

export const sortieVehiculeReset = () => ({ type: SORTIE_VEHICULE_RESET })

export function postVehiculeSortie(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: SORTIE_VEHICULE_BEGIN })
		return fetch(`${URL}api/vehicule/sortie`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch({ type: SORTIE_VEHICULE_SUCCESS })
				dispatch({
					type: FETCH_FLOTTE_SUCCESS,
					payload: { vehicules: json },
				})
				dispatch(
					showToast(
						"success",
						data.reintegrer
							? "Véhicule réintégré au parc"
							: "Véhicule sorti du parc",
					),
				)
			})
			.catch(
				catchApiError(
					dispatch,
					(error) => ({
						type: SORTIE_VEHICULE_ERROR,
						payload: { error },
					}),
					{ silent: true },
				),
			)
	}
}

export function deleteVehiculeConfig(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteVehiculeConfigBegin())
		return (
			fetch(`${URL}api/configuration/vehicule`, {
				method: "delete",
				headers: {
					Accept: "application/json, text/plain",
					"Content-type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				body: JSON.stringify({ id }),
			})
				.then(handleErrors)
				.then((res) => res.json())
				.then((json) => {
					dispatch(deleteVehiculeConfigSuccess(json))
					dispatch(showToast("success", "Véhicule supprimé"))
				})
				// silent : l'erreur s'affiche dans VehiculeV2 (règle hybride).
				.catch(
					catchApiError(dispatch, deleteVehiculeConfigError, {
						silent: true,
					}),
				)
		)
	}
}
